import style from './games.module.css'
import AnimatedSprite from '../animated/AnimatedSprite';
import Card from '../card/Card'

const Games = ({ visibleElements, elementsRef }) => {
    return (
        <section id={'games'} className={style['games']}
            ref={(el) => (elementsRef.current[16] = el)}>

            <div className={style['games__container']}>

                <h2 className={`${style['games__title']} 
                ${visibleElements.includes(elementsRef.current[17]) ?
                        style['games__title--transition'] : ''}`}>
                    Nuestros Videojuegos Indie.
                </h2>

                <div className={style['games__section']}
                    ref={(el) => (elementsRef.current[17] = el)}>

                    <h3 className={`${style['games__subtitle']} 
                    ${visibleElements.includes(elementsRef.current[17]) ?
                            style['games__subtitle--transition'] : ''}`}>
                        Descubre nuestras creaciones originales.
                    </h3>

                    <p className={`${style['games__description']} 
                    ${visibleElements.includes(elementsRef.current[17]) ?
                            style['games__description--transition'] : ''}`}>
                        Estamos enfocados en la creación de experiencias únicas en videojuegos.
                        trabajamos en nuevos proyectos que ofrecerán aventuras fascinantes.
                    </p>

                </div>

                <div className={style['games__animated']}
                    ref={(el) => (elementsRef.current[18] = el)}>

                    <AnimatedSprite visibleElements={visibleElements}
                        elementsRef={elementsRef} />

                </div>

                <div className={style['games__section']}
                    ref={(el) => (elementsRef.current[19] = el)}>

                    <Card visibleElements={visibleElements}
                        elementsRef={elementsRef} />

                </div>

                <div className={style['games__section']}
                    ref={(el) => (elementsRef.current[20] = el)}>

                    <h3 className={`${style['games__subtitle']} 
                    ${visibleElements.includes(elementsRef.current[20]) ?
                            style['games__subtitle--transition'] : ''}`}>
                        Mis redes OsoArtec sobre videojuegos.
                    </h3>

                    <p className={`${style['games__description']} 
                    ${visibleElements.includes(elementsRef.current[20]) ?
                            style['games__description--transition'] : ''}`}>
                        Comparto contenido sobre desarrollo de videojuegos indie,
                        análisis, tutoriales y más en mis redes sociales. <br /> ¡Sigue
                        mis actualizaciones y aprende más sobre el mundo del
                        desarrollo indie!
                    </p>

                    <div className={`${style['games__social']} 
                 ${visibleElements.includes(elementsRef.current[20]) ?
                            style['games__social--transition'] : ''}`}>

                        <a href='https://www.tiktok.com/@osoartec' target='_blank' rel='noopener noreferrer' className={style['games__social-link']}>
                            <i className='bi bi-tiktok'></i> TikTok - Videos cortos y análisis sobre videojuegos indie
                        </a>

                        <a href='https://www.youtube.com/channel/UCnK0ggqNupAh9961zcKJN3Q' target='_blank' rel='noopener noreferrer' className={style['games__social-link']}>
                            <i className='bi bi-youtube'></i> YouTube - Tutoriales y charlas sobre desarrollo de videojuegos
                        </a>

                        <a href='https://www.facebook.com/profile.php?id=61564478971946&notif_id=1729891497380222&notif_t=page_user_activity&ref=notif' target='_blank' rel='noopener noreferrer' className={style['games__social-link']}>
                            <i className='bi bi-facebook'></i> Facebook - Publicaciones, noticias y avances sobre mis proyectos
                        </a>

                        <a href='https://www.instagram.com/osoartec?igsh=MW8wY2VzNTk5azByMw==' target='_blank' rel='noopener noreferrer' className={style['games__social-link']}>
                            <i className='bi bi-instagram'></i> Instagram - Detrás de cámaras y mi día a día como desarrollador indie
                        </a>

                        <a href='https://x.com/OsoArTec' target='_blank' rel='noopener noreferrer' className={style['games__social-link']}>
                            <i className='bi bi-twitter'></i> Twitter - Opiniones, actualizaciones rápidas y noticias del mundo indie
                        </a>

                    </div>


                </div>

            </div>

        </section>
    );
};
export default Games;